import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Header from "../../global/header";
import Footer from "../../global/footer";
import Title from '../Title/Title';
import Language from '../Language/Langauge';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import './Error.css';
import tokenService from '../../service/token.service';

const Error = () => {

  const { t } = useTranslation();

  const handleClick = () => {
    tokenService.clearSessionData();
    window.location.replace(tokenService.getErrorRedirectUrl());
  }

  useEffect(() => {
    // use effect
  }, []);

  return (
    <>
      <Header />
      <Container className="error">
        <Row>
          <Col lg="1" />
          <Col lg="10" className="middlePadding">
            <div>
              <Title logoType="Success"> {t('TEXT_ERROR_PAGE_TITLE')} </Title>
              <Language />
            </div>
            <div className="mb-3">
              <Card className="card contentCard" text="black">
                <Card.Body>
                  <Card.Text className="cardText">
                    {t('TEXT_ERROR_CONTENT_INFO')}
                  </Card.Text>
                </Card.Body>
              </Card>
              <div className="d-grid gap-2">
                <Button
                  onClick={handleClick}
                  className="backBtn"
                >
                  {t('LABEL_ERROR_SUBMIT_BUTTON')}
                </Button>
              </div>
            </div>
            <Footer />
          </Col>
          <Col lg="1" />
        </Row>
      </Container>
    </>
  );
}

export default Error;
